import React, { useMemo } from 'react';

import { Icon } from '@column/column-ui-kit';

export const CurrencyIcon = ({ currencyCode }: { currencyCode?: string }) => {
  if (!currencyCode) return <Icon.Currency.USD />;

  const icon = useMemo(() => Icon.Currency[currencyCode as keyof typeof Icon.Currency], [currencyCode]);
  return icon ? React.createElement(icon) : <Icon.Currency.USD />;
};
